module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgBAMAAACBVGfHAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURTAwMEdwTDIyMjMzMzIyMjAwMDIyMjAwMDMzMzMzM/pPewcAAAAJdFJOUz8AgL9pENsgoOfTwMgAAAB0SURBVCjPYxBEAwzYBMQZAkFMAXaYgNBMRhBTchIugSCzmcnGQGA5zagQJCCaORMOpoIEBBD8mZNAAlATYKZgFXBggAJOqACGGRgCGFoI24JVQAToGUZkAZBdtBcgKTyQw3QKOBo6EQKGYAEBBjjAFdkoAAD+5WWeu0joqAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/MyinvitationsImg.png
// module id = 336
// module chunks = 0